export const shades = {
    dustyOrange:"#ED8335",
    lavender:"#B27EE3",
    black:"#000000",
    white:"#FFFFFF",
    silverTree:"#58BF87",
    royalBlue:"#2F66EC",
    racingGreen:"#121717"
}